import React from "react";
import Slide from "@material-ui/core/Slide";

const TransitionWrapper = React.forwardRef((props, ref) => {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default TransitionWrapper;
